<template>
  <button class="btn btn-primary" style="background-color: #0c0c72;" role="button">
    <slot/>
  </button>
</template>
